import Loader from '@/component/loader';
import React, { lazy, Suspense } from 'react';

export const lazyImport = (
	importFunc: () => Promise<{ default: React.ComponentType<any> }>,
) => {
	const LazyComponent = lazy(importFunc);
	return (props: any) => (
		<Suspense fallback={<Loader />}>
			<LazyComponent {...props} />
		</Suspense>
	);
};
